import { Model } from './Model';

export class ReportingDataResponse {
  public TrackingGuid: string;
  public CallerGuid: string;
  public Data: ReportingDataRow[];
}

export class PubCenterReportingDataResponse {
  public TrackingId: string;
  public DownloadUrl: string;
  public LatestAvailableDelta: string;
  public Data: PubCenterReportingDataRow[];
  public DataDelay?: boolean;
}

export class MediationReportingDataResponse {
  public trackingId: string;
  public data: MediationReportingDataRow[];
}

export class ReportingDataRow extends Model {
  public className: string = '';
  public apiPath: string = '';
}

export class PubCenterReportingDataRow extends ReportingDataRow {
  public AccountId?: string;
  public AccountName?: string;
  public AccountNumber?: string;
  public Currency?: string;
  public RequestedLanguage?: string;
  public RequestedCountry?: string;
  public WebsiteCountry?: string;
  public WebsiteLanguage?: string;
  public PublisherName?: string;
  public PublisherId?: number;
  public AdDistribution?: string;
  public Clicks?: number;
  public AdImpressions?: number;
  public SRPV?: number;
  public BiddedSRPVs?: number;
  public NonBillableSRPVs?: number;
  public EstimatedRevenue?: number;
  public EstimatedRevenueInUSD?: number;
  public AdDensity?: number;
  public CPC?: number;
  public BiddedCTR?: number;
  public AdCTR?: number;
  public BiddedRPM?: number;
  public Date?: string;
  public UserCountry?: string;
  public FormCode?: string;
  public DistributionPartnerCode?: string;
  public AdCountry?: string;
  public DeviceType?: string;
  public PartnerCode?: string;
  public PartnerTag?: string;
  public ImpactScore?: string;
  public Device?: string;
  public Market?: string;
  public RedirectionPhase?: string;
  public PTQSRemediationStatus?: string;
  public NumberOfWeeks?: number;
  public PTQS?: number;
  public RevenueSharePercent?: number;
  public Hour?: number;
}
export class TythonReportingDataRow extends ReportingDataRow {
  public DateTime?: string;
  public AccountId?: string;
  public AccountName?: string;
  public AdUnitId?: string;
  public AdUnitName?: string;
  public Country?: string;
  public CountryCode?: string;
  public ImpressionsServed?: number;
  public ImpressionsViewed?: number;
  public Viewability?: string;
  public Revenue?: number;
  public eCPM?: string;
  public Clicks?: number;
  public CTR?: string;
  public FillRate?: string;
}
export class MediationReportingDataRow extends ReportingDataRow {
  public AdUnitId?: string;
  public PubCenterAdUnitId?: string;
  public AdUnitName?: string;
  public SiteName?: string;
  public Country?: string;
  public Date?: string;
  public OperatingSystem?: string;
  public Revenue?: number;
  public Impressions?: number;
  public AdClicks?: number;
  public AdCTR?: string;
  public AdECPM?: string;
}
